// extracted by mini-css-extract-plugin
export default {"container":"NightGuardPage_container__L-1Bn","title":"NightGuardPage_title__omzc+"};